import axios from 'axios'
import { notification, message } from 'ant-design-vue';
import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams } from "@/utils/common";
import cache from '@/plugins/cache'
import { EventBus } from '@/utils/event-bus'

// 是否显示重新登录
export let isRelogin = { show: false };
// 是否报错提示
export let isErrorMsg = false;
const LOGIN_EXPIRED_MESSAGE_KEY = 'loginExpiredMessage';
const NO_TOKEN_REQUEST_ERROR = 'NO_TOKEN_REQUEST_ERROR';

function redirectToLoginWithMessage(msg) {
  sessionStorage.setItem(LOGIN_EXPIRED_MESSAGE_KEY, msg)
  location.href = '/login'
}

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时  * 60
  timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  const token = getToken()
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  isErrorMsg = (config.headers || {}).isErrorMsg === false
  if (!token && !isToken) {
    const loginExpiredMessage = '登录状态已失效请重新登录！'
    if (!isRelogin.show && location.pathname !== '/login') {
      isRelogin.show = true
      location.href = '/login'
    }
    const noTokenError = new Error(loginExpiredMessage)
    noTokenError.code = NO_TOKEN_REQUEST_ERROR
    return Promise.reject(noTokenError)
  }
  if (token && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  // post请求映射params参数
  if (config.method === 'post' && config.data && config.data.pageNum) {
    let url = config.url + '?' + tansParams(config.data);
    url = url.slice(0, -1);
    config.url = url;
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;                  // 请求地址
      const s_data = sessionObj.data;                // 请求数据
      const s_time = sessionObj.time;                // 请求时间
      const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = '数据正在处理，请勿重复提交';
        console.warn(`[${s_url}]: ` + message)
        console.log(`[${s_url}]: `, requestObj)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
      return res.data
    }
    if (code === 401) {
      const loginExpiredMessage = res.data.msg ? res.data.msg : '登录状态已过期请重新登录！'
      console.log('loginExpiredMessage', loginExpiredMessage,res)
      if (!isRelogin.show) {
        isRelogin.show = true;
        if(Object.keys(store.getters.user).length !== 0){
          isRelogin.show = false;
          store.dispatch('LogOut').then(() => {
            redirectToLoginWithMessage(loginExpiredMessage)
          })
        }else{
          isRelogin.show = false;
          store.dispatch('FedLogOut').then(() => {
            redirectToLoginWithMessage(loginExpiredMessage)
          })
        }
      }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 1000) {
      EventBus.emit('errChange', res.data)
      localStorage.setItem('errorCode', code)
      // message.warning('当前登录企业已被禁用，请切换企业！')
      console.log('location.href',location.href.includes('/project'))
      if(!location.href.includes('/project')){
        location.href = '/project';
      }
      return Promise.reject(res.data)
    } else if (code === 500) {
      if(!isErrorMsg){
        console.log(isErrorMsg)
        message.error(msg)
      }
      return Promise.reject(res.data)
    } else if (code === 601) {
      message.warning(msg)
      return Promise.reject('error')
    } else if (code !== 200) {
      notification.error({ message: msg })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    if (error?.code === NO_TOKEN_REQUEST_ERROR) {
      return Promise.reject(error)
    }
    console.log('err' + error)
    let messageInfo = error.message
    console.log(messageInfo)
    if (messageInfo == "Network Error") {
      messageInfo = "后端接口连接异常";
    } else if (messageInfo.includes("timeout")) {
      messageInfo = "系统接口请求超时";
    } else if (messageInfo.includes("Request failed with status code")) {
      messageInfo = "系统接口" + messageInfo.substr(messageInfo.length - 3) + "异常";
    }
    // { message: message, type: 'error', duration: 5 * 1000 }
    message.error(messageInfo)
    return Promise.reject(error)
  }
)
export default service
